<template>
    <b-card class="mb-4" header-bg-variant="custom" no-body>
        <template #header>
            <h4 class="text-white">{{ title }}</h4>
        </template>
        <b-card-body>
            <b-row>
                <b-col class="col-12" v-if="period_info">
                    <p class="text-muted">{{ period_info }}</p>
                </b-col>
                <b-col class="col-12 table-responsive">

                    <!-- Table with total of provenances -->
                    <b-row class="mt-2">
                        <b-col>
                            <b-row>
                                <b-col class="text-right">
                                    <download-excel v-if="this.json_fields" class="btn btn-primary" :data="json_data"
                                        :fields="json_fields" name="export.xls">
                                        <font-awesome-icon icon="file-excel"></font-awesome-icon>&nbsp;
                                        {{ $t("general.download_data") }}
                                    </download-excel>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-table hover striped :items="items" :fields="fields" :per-page="20"
                                        :current-page="current_page"
                                        :class="this.competitorName ? 'competitors mt-2' : 'mt-2'">
                                        <template #thead-top v-if="this.competitorName">
                                            <b-tr>
                                                <th rowspan="2">{{ $t("dashboard.provenance.countries") }}</th>
                                                <th colspan="2">{{ $t("dashboard.kpi.overnights.header") }}</th>
                                                <th colspan="2">{{ $t("legends.evoPercent") }}</th>
                                                <th colspan="2">{{ $t("legends.evoReal") }}</th>
                                                <th colspan="2">{{ $t("legends.marketShare") }}</th>
                                            </b-tr>
                                            <b-tr>
                                                <th>{{ $t("general.zurichStadt") }}</th>
                                                <th>{{ competitorName }}</th>
                                                <th>{{ $t("general.zurichStadt") }}</th>
                                                <th>{{ competitorName }}</th>
                                                <th>{{ $t("general.zurichStadt") }}</th>
                                                <th>{{ competitorName }}</th>
                                                <th>{{ $t("general.zurichStadt") }}</th>
                                                <th>{{ competitorName }}</th>
                                            </b-tr>
                                        </template>

                                        <template v-slot:cell(evolution)="{ item }">
                                            <span :class="getTextVariant(item.evolution_real_num)">{{
                                                item.evolution
                                            }}</span>
                                        </template>

                                        <template v-slot:cell(evolution_real)="{ item }">
                                            <span :class="getTextVariant(item.evolution_real_num)">{{
                                                item.evolution_real
                                            }}</span>
                                        </template>

                                        <template v-slot:cell(benchEvolution)="{ item }">
                                            <span :class="getTextVariant(item.evolution_real_num)">{{
                                                item.benchEvolution
                                            }}</span>
                                        </template>

                                        <template v-slot:cell(benchEvolution_real)="{ item }">
                                            <span :class="getTextVariant(item.evolution_real_num)">{{
                                                item.benchEvolution_real
                                            }}</span>
                                        </template>
                                    </b-table>
                                </b-col>
                            </b-row>

                            <b-row class="mt-1">
                                <b-col>
                                    <b-pagination v-model="current_page" :total-rows="rows" :per-page="20" size="sm"
                                        first-number last-number pills />
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
export default {
    props: {
        title: { type: String, required: true },
        items: { type: Array, required: true },
        fields: { type: Array, required: true },
        json_fields: { type: Object, default: null },
        caption: { type: String, default: "Table" },
        overnights: { type: Boolean, default: true },
        competitorName: { type: String, default: null },
        period_info: { type: String, default: null },
        hover: Boolean,
        striped: Boolean,
        bordered: Boolean,
        small: Boolean,
        fixed: Boolean,
        dark: Boolean,
    },
    data() {
        return {
            totalList: false,
            card: {
                title: null,
            },
            table: {
                header: null,
                content: null,
            },
            current_page: 1,
            json_markets: null,
            json_data: null,
        };
    },
    created() {
        this.card.title = this.title;
        this.json_markets = JSON.parse(JSON.stringify(this.mainMarkets));
        this.json_data = JSON.parse(JSON.stringify(this.items));
    },
    methods: {
        getBadge(evolution) {
            return evolution > 0 ? "success" : "danger";
        },
        getTextVariant(evolution) {
            return evolution >= 0 ? "text-success" : "text-danger";
        },
    },
    computed: {
        rows() {
            return this.items.length;
        },
    },
};
</script>

<style lang="scss">
.badge-danger {
    color: #fff;
    background-color: #e55353 !important;
}

.badge-success {
    color: #fff;
    background-color: #2eb85c !important;
}

.competitors>thead>tr:last-child {
    display: none;
}
</style>
